import * as Api from './service'
interface IStatusChangeList {
  date: string
  content: string
  subContent: string[]
}
const defaultStatusChangeList: IStatusChangeList[] = []
export default {
  namespace: 'changeRecord',
  state: {
    cityImprovementRule: [],
    statusChangeList: defaultStatusChangeList,
    improvementInfo: {
      improvementNum: '',
      nextSilentHour: ''
    }
  },
  effects: {
    * queryStatusChangeList ({ payload }, { call, put }) {
      const {
        data: {
          data: { statusChangeList, improvementInfo }
        }
      } = yield call(Api.queryStatusChangeList, payload)
      const statusChangeListTemp: IStatusChangeList[] = []
      statusChangeList.map(item => {
        statusChangeListTemp.push({
          date: item.dateTime,
          content: item.context,
          subContent: item.reasonList
        })
      })
      yield put({
        type: 'save',
        payload: {
          statusChangeList: statusChangeListTemp,
          improvementInfo
        }
      })
    },
    * queryCityImprovementRule ({ payload }, { call, put }) {
      const {
        data: { data }
      } = yield call(Api.queryCityImprovementRule, payload)
      yield put({
        type: 'save',
        payload: {
          cityImprovementRule: data
        }
      })
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
